export const ZONE_SET_DATA = 'ZONE_SET_DATA';
export const ZONE_SET_LAST_PAGE = 'ZONE_SET_LAST_PAGE';
export const ZONE_SET_TOTAL_ROWS = 'ZONE_SET_TOTAL_ROWS';
export const ZONE_SET_CURRENT_ROW = 'ZONE_SET_CURRENT_ROW';
export const ZONE_SET_RELOAD_DATA = 'ZONE_SET_RELOAD_DATA';
export const ZONE_SET_LOADING = 'ZONE_SET_LOADING';
export const ZONE_TOGGLE_CREATE_EDIT_MODAL = 'ZONE_TOGGLE_CREATE_EDIT_MODAL';

export const ZoneType = {
  ENGAGEMENT: 1,
  QUEUE: 2,
  ORDER: 3,
  COLLECTION: 4,
};

export const ZoneTypeText = {
  [ZoneType.ENGAGEMENT]: 'Engagement',
  [ZoneType.QUEUE]: 'Queue',
  [ZoneType.ORDER]: 'Order',
  [ZoneType.COLLECTION]: 'Collection',
};
